import type { ChildrenType } from "@/types/types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    Navigate,
    useParams,
    useNavigate,
    useLocation,
} from "react-router-dom";
import SeoHead from "@/components/seo/SeoHead";

export default function LanguageRouter({ children }: ChildrenType) {
    const { lang } = useParams();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const savedLang = localStorage.getItem("preferredLang");
    const validSavedLang =
        savedLang && ["id", "en", "my"].includes(savedLang) ? savedLang : null;

    useEffect(() => {
        if (lang && ["id", "en", "my"].includes(lang)) {
            if (!validSavedLang || lang === validSavedLang) {
                i18n.changeLanguage(lang);
                localStorage.setItem("preferredLang", lang);
            }
        }
    }, [lang, i18n, validSavedLang]);

    useEffect(() => {
        // Strategi 1: Prioritaskan localStorage jika user melakukan Back/Forward navigation
        if (
            lang &&
            validSavedLang &&
            lang !== validSavedLang &&
            ["id", "en", "my"].includes(lang)
        ) {
            const currentPath = window.location.pathname;
            const currentSearch = window.location.search;
            const newPath = currentPath.replace(
                new RegExp(`^/${lang}`),
                `/${validSavedLang}`,
            );
            navigate(`${newPath}${currentSearch}`, {
                replace: true,
                state: location.state,
            });
        }
    }, [lang, validSavedLang, navigate, location.state]);

    if (!lang || !["id", "en", "my"].includes(lang)) {
        const defaultLang = validSavedLang ? validSavedLang : "id";

        // Jika URL awal bukan language code (misal /reset-password),
        // kita tambahkan defaultLang di depannya agar path dan query tidak hilang
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;

        // Kita hanya mengalihkan jika lang tidak valid.
        return (
            <Navigate
                to={`/${defaultLang}${currentPath !== "/" ? currentPath : ""}${currentSearch}`}
                replace
                state={location.state}
            />
        );
    }

    return (
        <>
            <SeoHead />
            {children}
        </>
    );
}
